import { createAction, props } from '@ngrx/store';
import { AccountingMode, CompanyData } from '../model/accounting.model';

export const getReferenceData = createAction('[Reference] get reference data');
export const getReferenceDataSuccess = createAction(
  '[Reference] get reference data success',
  props<{ companyData: CompanyData }>()
);
export const getReferenceDataError = createAction('[Reference] get reference data error', props<{ error: string }>());

export const toggleOpenedStatus = createAction('[FlowTable] toggle account opened status', props<{ accountNo: number }>());

export const displayIntermediaryAccountGroupsChanged = createAction(
  '[FlowTable] display intermediary account groups changed',
  props<{ enabled: boolean }>()
);

export const openAllRows = createAction('[FlowTable] open all rows for account');
export const openFirstLevel = createAction('[FlowTable] open first level for account');
export const closeAllRows = createAction('[FlowTable] close all rows for account');


export const setAccountingMode = createAction('[Accounting] set accounting mode', props<{ mode: AccountingMode }>());
